module.exports = __webpack_public_path__ + "static/media/matched.d83a9d35.svg";